export * from './image-record-view.component';
